<template>
    <div v-scrollspy class="sticky-top bg-white bar" v-once>
        <mvtShifter type="2">
            <a v-scroll href="#snapshotPanel" v-if="glb.pageType.indexOf('vagentsearch') > -1 && data.isSnapshotDataAvailable" data-target="snapshotPanel">Market Snapshot</a>
            <a v-scroll href="#agentTipsPanel">Agent Performance</a>
            <a v-scroll href="#agentProcessPanel">Process</a>
            <a v-scroll href="#agentFaqPanel" v-if="!isAgentCityPage">FAQ</a>
            <a v-scroll href="#agentToolLinkPanel">Tools</a>
            <a v-scroll href="#agentBrokeragePanel" v-if="currentBrokerage">Movoto Agents</a>
        </mvtShifter>
    </div>
</template>
<script src="./agent-bar.js"></script>
